import log from 'salvo-lite/log'
import getNodeDimensions from 'get-node-dimensions'

class Footer {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        this.doHeight()

        window.addEventListener('resize', e => {
            this.doHeight()
        })

        log.debug(this.constructor.name, 'Initiated')
    }

    doHeight () {
        this._elem.parentNode.style.height = `${getNodeDimensions(this._elem).height}px`
    }
}

export default Footer



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Footer.js